import { createContext, useContext, useEffect, useState, ReactNode } from "react";
import { apiSuperAdmin } from "../api/client";

interface SuperAdmin {
  id: string;
  nombre: string;
  email: string;
}

interface SuperAdminAuthValue {
  superAdmin: SuperAdmin | null;
  cargando: boolean;
  login: (email: string, password: string) => Promise<void>;
  logout: () => void;
}

const SuperAdminAuthContext = createContext<SuperAdminAuthValue | null>(null);

export function SuperAdminAuthProvider({ children }: { children: ReactNode }) {
  const [superAdmin, setSuperAdmin] = useState<SuperAdmin | null>(null);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem("vetflow_superadmin_token");
    if (!token) {
      setCargando(false);
      return;
    }
    apiSuperAdmin
      .get("/superadmin/auth/me")
      .then((res) => setSuperAdmin(res.data))
      .catch(() => localStorage.removeItem("vetflow_superadmin_token"))
      .finally(() => setCargando(false));
  }, []);

  async function login(email: string, password: string) {
    const res = await apiSuperAdmin.post("/superadmin/auth/login", { email, password });
    localStorage.setItem("vetflow_superadmin_token", res.data.token);
    setSuperAdmin(res.data.superAdmin);
  }

  function logout() {
    localStorage.removeItem("vetflow_superadmin_token");
    setSuperAdmin(null);
    window.location.href = "/superadmin/login";
  }

  return (
    <SuperAdminAuthContext.Provider value={{ superAdmin, cargando, login, logout }}>
      {children}
    </SuperAdminAuthContext.Provider>
  );
}

export function useSuperAdminAuth() {
  const ctx = useContext(SuperAdminAuthContext);
  if (!ctx) throw new Error("useSuperAdminAuth debe usarse dentro de <SuperAdminAuthProvider>");
  return ctx;
}
